import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { environment } from '@environments/environment';
import { CardModule } from 'primeng/card';
import { AboutGroups } from './model/about-group';
import { AboutSectionComponent } from './about-section/about-section.component';
import { AppService } from 'app/app.service';
import { SignalsService } from '@shared/services/signals/signals.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-about',
  standalone: true,
  imports: [
    CommonModule,
    CardModule,
    AboutSectionComponent
  ],
  templateUrl: './about.component.html',
  styleUrl: './about.component.scss'
})
export class AboutComponent implements OnInit, OnDestroy {

  constructor(
    public appService: AppService,
    private signalService: SignalsService
  ) {}

  adminSub!: Subscription;

  version: string = `${environment.appVersion}`;
  generalDataGroups?: AboutGroups;
  faqDataGroups?: AboutGroups;
  legalDataGroups?: AboutGroups;
  isAdmin: boolean = false;

  ngOnInit(): void {
    this.adminSub = this.signalService.isAdminRole$.subscribe( (isAdmin) => {
      this.isAdmin = isAdmin;
      this.generalDataGroups = this.getGeneralDataGroups();
      this.faqDataGroups = this.getFaqDataGroups();
      this.legalDataGroups = this.getLegalDataGroups();
    });
  }

  getGeneralDataGroups(): AboutGroups {
    return {
     title: 'General',
     aboutMenuGroups: [
       {
         groupsItems: [
           {
             name: 'Version Details',
             type: 'static',
             icon: 'pi pi-info-circle',
             iconColor: 'background: var(--blue-500)',
             path: 'version'
           },
           {
             name: 'Feedback',
             type: 'static',
             icon: 'pi pi-at',
             iconColor: 'background: var(--green-500)',
             path: 'feedback'
           }
         ]
       }
     ]
   }
  }

  getFaqDataGroups(): AboutGroups {

    if (this.isAdmin) {
      return {
        title: 'Faq',
        aboutMenuGroups: [
          {
            groupsItems: [
              {
                name: 'General',
                type: 'static',
                icon: 'pi pi-question-circle',
                iconColor: 'background: var(--red-500)',
                path: 'general'
              },
              {
                name: 'Flights',
                type: 'static',
                icon: 'pi pi-list',
                iconColor: 'background: var(--bluegray-500)',
                path: 'flights'
              },
              {
                name: 'Analyze',
                type: 'static',
                icon: 'pi pi-history',
                iconColor: 'background: var(--text-secondary)',
                path: 'analyze'
              },
              {
                name: 'Search',
                type: 'static',
                icon: 'pi pi-search',
                iconColor: 'background: var(--indigo-500)',
                path: 'search'
              },
              {
                name: 'Admin',
                type: 'static',
                icon: 'pi pi-users',
                iconColor: 'background: var(--orange-500)',
                path: 'admin'
              }
            ]
          }
        ]
      }
    }
    else {
      return {
        title: 'Faq',
        aboutMenuGroups: [
          {
            groupsItems: [
              {
                name: 'General',
                type: 'static',
                icon: 'pi pi-question-circle',
                iconColor: 'background: var(--red-500)',
                path: 'general'
              },
              {
                name: 'Flights',
                type: 'static',
                icon: 'pi pi-list',
                iconColor: 'background: var(--bluegray-500)',
                path: 'flights'
              },
              {
                name: 'Analyze',
                type: 'static',
                icon: 'pi pi-history',
                iconColor: 'background: var(--text-secondary)',
                path: 'analyze'
              },
              {
                name: 'Search',
                type: 'static',
                icon: 'pi pi-search',
                iconColor: 'background: var(--indigo-500)',
                path: 'search'
              }
              
            ]
          }
        ]
      }
    }
  }

  getLegalDataGroups(): AboutGroups {
    return {
      title: 'Application',
      aboutMenuGroups: [
        {
          groupsItems: [
            {
              name: 'Legal Disclaimer',
              type: 'static',
              disabled: false,
              icon: 'pi pi-lock',
              iconColor: 'background: var(--blue-500)',
              path: 'disclaimer'
            }
          ]
        }
      ]
    }
  }

  ngOnDestroy(): void {
    this.adminSub?.unsubscribe();
  }

}
